class NotifyPopup extends HTMLElement {
    connectedCallback() {
        this.closeBtns = this.querySelectorAll('[data-product-notify-close]');
        this.tagsInput = this.querySelector('[data-notify-tags]');


        document.addEventListener('popup:notify:open', (e) => this.open(e.detail));

        this.closeBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        });

        this.addEventListener('click', (e) => {
            if (e.target === this) {
                this.close();
            }
        });
    }


    open(detail) {
        if (this.tagsInput) {
            this.tagsInput.value = `notify-me, product:${detail.handle}, variant:${detail.variantId}`;
        }

        this.style.display = 'flex';
        document.body.style.overflow = 'hidden'; 
    }

    close() {
        this.style.display = 'none';
        document.body.style.overflow = '';
    }
}

if (!customElements.get('notify-popup')) {
    customElements.define('notify-popup', NotifyPopup);
}